// Packages
import { Component } from "react";
import { Link, withRouter } from "react-router-dom";

// Views
import Header from "./header";
import close from "../../assets/images/crosstick.png";
import successimg from "../../assets/images/successimg.png";
// Assets
import Activate from "../../assets/images/Activate.png";
import contendZONEBlack from "../../assets/images/contendZONEViolet.png";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

// Services
import userService from "../../services/user.service";

//Utils
import { validateForm } from "../../utils/validateFrom";
import { getQueryparams } from "../../utils";
// common email
import { emailAddress } from "../../common";
import { BsXLg } from "react-icons/bs";

class SetOwnPassord extends Component {
  constructor() {
    super();
    this.state = {
      errors: {},
      token: "",
      password: "",
      confirmPassword: "",
      type: "password",
      type1: "password",
    };

    this.submitPassword = this.submitPassword.bind(this);
  }

  componentDidMount() {
    const {
      location: { search },
    } = this.props;
    this.token = getQueryparams(search, "token");
    console.log(this.token);
  }

  submitPassword(e) {
    e.preventDefault();
    const { password, confirmPassword } = this.state;
    const { history } = this.props;
    const { errors, formIsValid } = validateForm({
      password,
      confirmPassword,
    });
    this.setState({
      errors,
      submitting: true,
    });
    if (formIsValid) {
      const { password, confirmPassword } = this.state;
      userService
        .setOwnPassword(this.token, password, confirmPassword)
        .then((response) => {
          if (response.status === 200) {
            // alert("Password reset successfully.");
            this.openDialogRemoved();
          } else {
            alert("Something went wrong");
          }
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    }
  }

  handleClick = () =>
    this.setState(({ type }) => ({
      type: type === "text" ? "password" : "text",
    }));
  handleClickconpass = () =>
    this.setState(({ type1 }) => ({
      type1: type1 === "text" ? "password" : "text",
    }));

  handleKeyPress = (event) => {
    if (event.key === "Enter") {
      this.submituserRegistrationForm();
    }
  };
  passwordHandled(e) {
    this.setState({
      password: e.target.value,
      confirmPassword: e.target.value,
    });
  }

  openDialogRemoved() {
    this.setState({ openRemove: !this.state.openRemove });
  }
  closeDialogRemoved() {
    this.setState({ openRemove: !this.state.openRemove });
  }

  render() {
    const { type, password, confirmPassword, errors, type1 } = this.state;
    return (
      <div>
        {/* <InternalHeader></InternalHeader> */}
        <div className="dnone">
          <Header></Header>
        </div>
        <section className="contact-section">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-5 col-lg-5 mx-auto text-center">
              <Link to="/">
                <img
                  src={contendZONEBlack}
                  alt="logo"
                  className="logostyle ml-3 img-fluid mobilehide cp"
                  data-toggle="dropdown"
                  to="/home"
                />
              </Link>
              <div className="login-box mt-5">
                <div className="clear20"></div>
                <h6 className="fs-24 bold dblack">Set your own Password</h6>
                <div className="clear10"></div>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                  <label className="black fs-20 semi-bold float-left m-0">
                    New Password
                  </label>
                  <div className="clear"></div>
                  <input
                    type={type}
                    className="fs-24 black semi-bold fm-input olnone w-100"
                    name="password"
                    id="password"
                    placeholder=""
                    value={password}
                    onChange={(e) => {
                      this.setState({ password: e.target.value });
                    }}
                    onKeyPress={this.handleKeyPress}
                  ></input>
                  {/* value={password}   onChange={(e)=>{this.setState({password:e.target.value})}} */}
                  <span className="password__show" onClick={this.handleClick}>
                    <img src={Activate} alt="eye" />
                  </span>
                  <div className="errorMsg fs-14 medium">{errors.password}</div>
                  <div className="clear20"></div>
                  <label className="black fs-20 semi-bold float-left m-0">
                    Confirm Password
                  </label>
                  <div className="clear"></div>
                  <input
                    type={type1}
                    className="fs-24 black semi-bold fm-input olnone w-100"
                    name="confirmPassword"
                    id="confirmPassword"
                    placeholder=""
                    value={confirmPassword}
                    onChange={(e) => {
                      this.setState({ confirmPassword: e.target.value });
                    }}
                  ></input>
                  <span
                    className="password__show"
                    onClick={this.handleClickconpass}
                  >
                    <img src={Activate} alt="eye" />
                  </span>
                  <div className="errorMsg fs-14 medium">
                    {errors.confirmPassword}
                  </div>
                  <div className="clear5"></div>
                  {/* <span className="txtblue cp txtdul float-right bold fs-16">Forgot Password?</span> */}
                  <div className="clear10"></div>
                  <div className="clear20"></div>
                  <button
                    type="submit"
                    className="submit-btn fs-28 regular white w-100"
                    onClick={this.submitPassword}
                  >
                    Create Password and Login
                  </button>
                  <div className="clear20"></div>
                  {/* <span className="fs-16 medium notRegistered">Not Registered?</span> */}
                  {/* <Link to="/signUp"> <span className="fs-16 regular bold txtblue"><u>Sign Up</u></span></Link> */}
                </div>
              </div>
              <div className="clear20"></div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 text-center">
                {/* <span className="fs-16 medium notRegistered">To know more about our products </span><span className="fs-16 medium txtblue"><u>Request Demo</u></span> */}
              </div>
            </div>
          </div>

          <Dialog
            id="dialogBoxRemove"
            className="dialog-style"
            open={this.state.openRemove}
            onClose={this.closeDialogRemoved.bind(this)}
          >
            <DialogTitle>
              <div className="row">
                <div className="col-1 text-right ml-auto mr-4">
                  <BsXLg
                    onClick={this.closeDialogRemoved.bind(this)}
                    className="crossview cp"
                  ></BsXLg>
                </div>
              </div>
            </DialogTitle>
            <DialogContent>
              <div className="clear10"></div>
              <div className="row">
                <div className="col-12 text-center">
                  <img
                    src={successimg}
                    alt="success"
                    className="successimg-new"
                  ></img>
                  <p className="fs-20 semi-bold text-center">
                    Password Set Successfully!
                  </p>
                  <div className="clear10"></div>
                </div>
                <div className="col-12 col-md-12 col-lg-12 ml-auto text-center">
                  <Link className="" to="/login">
                    <button
                      type="button"
                      class="donebtn"
                      onClick={this.closeDialogRemoved.bind(this)}
                    >
                      DONE
                    </button>
                  </Link>
                </div>
              </div>

              <div className="clear10"></div>

              <div className="clear10"></div>
            </DialogContent>
          </Dialog>
          {/* end  */}
          <div className="clear10"></div>
          <div className="">
            <div className="row log-footer-p w-95 m-0">
              <div className="clear50"></div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 pt-3">
                <h6 className="fs-16 medium notRegistered">
                  `Copyright © {new Date().getFullYear()} - All rights reserved
                  | CONTENDZONE | Disclaimer | Privacy Policy`
                </h6>
              </div>
              <div className="fs-16 medium txtblue col-12 col-sm-12 col-md-6 col-lg-6 text-right pt-3">
                <span className="fs-16 medium txtblue mr-5">
                  {emailAddress}
                </span>
                <span className="black"></span>{" "}
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default withRouter(SetOwnPassord);
